import { ReactElement } from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import get from 'lodash/get';
import classnames from 'classnames';
import TextField from '@material-ui/core/TextField';

import styles from './Textarea.module.scss';

interface IProps {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  rows?: number;
  size?: 'medium' | 'small';
  name: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
}

const Textarea = ({
  register,
  errors,
  rows = 4,
  size = 'medium',
  name,
  label = '',
  required = false,
  disabled = false,
  placeholder = '',
  className,
}: IProps): ReactElement => {
  const { ref, ...registerProps } = register(name);

  const error = get(errors, `${name}.message`, '');

  return (
    <TextField
      {...registerProps}
      inputRef={ref}
      variant="outlined"
      multiline
      rows={rows}
      size={size}
      className={classnames(styles.textarea, className)}
      disabled={disabled}
      placeholder={placeholder}
      label={label}
      required={required}
      InputLabelProps={{ shrink: true }}
      error={Boolean(error)}
      helperText={error}
    />
  );
};

export default Textarea;
